import { createSignal, type JSX } from 'solid-js';
import { copyToClipboard } from '../lib/format';
import { IconButton } from '../ui/Button';
import { Icon } from '../ui/Icon';

export function CopyLine(props: { text: string; label?: string }): JSX.Element {
  const [copied, setCopied] = createSignal(false);
  return (
    <div class="copy-line">
      <span class="copy-line__text">{props.text}</span>
      <IconButton
        label={props.label ?? 'Copy'}
        small
        onClick={async () => {
          if (await copyToClipboard(props.text)) {
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
          }
        }}
      >
        <Icon name={copied() ? 'check' : 'copy'} size={14} />
      </IconButton>
    </div>
  );
}
